/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na iterátory plánu obsahových úloh
 */
class ContentTaskPlanIteratorFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ContentTaskPlanIterator>} ContentTaskPlanIterator
   * @param {IcalApi} ICAL
   * @param {IcalExpander} expander
   * @param {number} maxInterval Maximální délka intervalu,
   * ve kterém se vyhledávají události. [s]
   * @param {IcalTimeUtil} timeUtil
   */
  constructor(ContentTaskPlanIterator, ICAL, expander, maxInterval, timeUtil) {
    this.ContentTaskPlanIterator = ContentTaskPlanIterator;
    this.ICAL = ICAL;
    this.expander = expander;
    this.maxInterval = maxInterval;
    this.timeUtil = timeUtil;
  }

  /**
   * Vytvoří nový iterátor.
   * @param {Date} atDate Okamžik, od kterého se má začít vytvářet plán.
   * @param {Array.<ContentTask>} contentTasks Obsahové úlohy, pro které se vytvoří plán.
   * Pořadí úloh je od nejdůležitější po nejméně důležitou.
   * @returns {ContentTaskPlanIterator}
   */
  create(atDate, contentTasks) {
    return new this.ContentTaskPlanIterator(
      this.ICAL,
      atDate,
      contentTasks,
      this.expander,
      this.maxInterval,
      this.timeUtil
    );
  }
}

export default ContentTaskPlanIteratorFactory;
